module.exports = __webpack_public_path__ + "static/media/yardnapha_got_2.24d8e095.png";